import { render } from "./GlobalDefinitionIcon.vue?vue&type=template&id=26e96c56&ts=true"
import script from "./GlobalDefinitionIcon.vue?vue&type=script&lang=ts"
export * from "./GlobalDefinitionIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__